import React from "react";
import { Grid } from "semantic-ui-react";
import CheckboxCard from "./CheckboxCard";

const StepFiveCheckbox = () => (
  <Grid>
    <Grid.Row>
      <Grid.Column>
        <CheckboxCard Text="Recite all the verses you took for the entire page all together while only looking at the Quran when you need to" Note="Make correlations for every ayah. As well as read the entire page without looking in English. (If you actually know the meaning, and know what comes after what, then the Arabic will be much easier)" Count="10" />
      </Grid.Column>
    </Grid.Row>
  </Grid>
)
export default StepFiveCheckbox;